import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickGuideCards = ({ onSelectGuide }) => {
  const quickGuides = [
    {
      id: 'first-time',
      title: 'First-Time Buyer\'s Guide',
      description: 'Essential knowledge for your first vacuum purchase',
      icon: 'GraduationCap',
      color: 'bg-blue-500',
      readTime: '8 min read',
      popularity: 'Most Popular',
      features: ['Basic terminology', 'Must-have features', 'Common mistakes to avoid']
    },
    {
      id: 'pet-owners',
      title: 'Pet Owner\'s Complete Guide',
      description: 'Specialized solutions for homes with furry friends',
      icon: 'Heart',
      color: 'bg-green-500',
      readTime: '12 min read',
      popularity: 'Trending',
      features: ['Pet hair removal', 'Odor elimination', 'Allergen control']
    },
    {
      id: 'budget-friendly',
      title: 'Budget-Conscious Guide',
      description: 'Maximum cleaning power without breaking the bank',
      icon: 'DollarSign',
      color: 'bg-purple-500',
      readTime: '10 min read',
      popularity: 'Value Pick',
      features: ['Under $200 options', 'Cost per use analysis', 'Long-term value']
    },
    {
      id: 'luxury-premium',
      title: 'Premium & Luxury Guide',
      description: 'High-end vacuums for discerning homeowners',
      icon: 'Crown',
      color: 'bg-amber-500',
      readTime: '15 min read',
      popularity: 'Expert Choice',
      features: ['Premium brands', 'Advanced technology', 'Professional results']
    }
  ];

  return (
    <section className="py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Quick Start Guides
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Jump straight to the guide that matches your situation. Each guide is crafted by our experts with real-world testing data and honest recommendations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {quickGuides?.map((guide) => (
            <div
              key={guide?.id}
              className="bg-white rounded-xl shadow-subtle hover:shadow-floating transition-all duration-300 overflow-hidden group cursor-pointer"
              onClick={() => onSelectGuide(guide?.id)}
            >
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className={`${guide?.color} p-3 rounded-lg`}>
                    <Icon name={guide?.icon} size={24} className="text-white" />
                  </div>
                  <span className="text-xs font-medium text-accent bg-accent/10 px-2 py-1 rounded-full">
                    {guide?.popularity}
                  </span>
                </div>
                
                <h3 className="text-lg font-semibold text-text-primary mb-2 group-hover:text-primary transition-colors">
                  {guide?.title}
                </h3>
                <p className="text-sm text-text-secondary mb-4 line-clamp-2">
                  {guide?.description}
                </p>
                
                <div className="space-y-3 mb-6">
                  {guide?.features?.map((feature, index) => (
                    <div key={index} className="flex items-center text-sm text-text-secondary">
                      <Icon name="Check" size={14} className="text-success mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
                
                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <span className="text-xs text-text-secondary flex items-center">
                    <Icon name="Clock" size={12} className="mr-1" />
                    {guide?.readTime}
                  </span>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="ArrowRight"
                    iconPosition="right"
                    className="text-primary hover:text-primary/80"
                  >
                    Read Guide
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickGuideCards;